
export default class CabinPrice {
    id;
    name;
    display_name;
    display_name_en;
    cabin;
    weeks;
    price_day;
    price_week;
    price_sun_to_thur;
    price_thur_to_sun;
    block_partial_periods;

    constructor(dict) {
        this.id = dict["id"];
        this.name = dict["name"];
        this.display_name = dict["display_name"];
        this.display_name_en = dict["display_name_en"];
        this.cabin = dict["cabin"];
        this.weeks = dict["weeks"];
        this.price_day = dict["price_day"];
        this.price_week = dict["price_week"];
        this.price_sun_to_thur = dict["price_sun_to_thur"];
        this.price_thur_to_sun = dict["price_thur_to_sun"];
        this.block_partial_periods = dict["block_partial_periods"];
        this.created = new Date(dict["created"]);
    }

    toDict() {
        return {
            "name" : this.name,
            "display_name" : this.display_name,
            "display_name_en" : this.display_name_en,
            "cabin" : this.cabin,
            "weeks" : this.weeks,
            "price_day" : this.price_day,
            "price_week" : this.price_week,
            "price_sun_to_thur" : this.price_sun_to_thur,
            "price_thur_to_sun" : this.price_thur_to_sun,
            "block_partial_periods" : this.block_partial_periods
        };
    }

    getCabinString() {
        if (this.cabin == 1) {
            return "Storstugan"
        } else if (this.cabin == 2) {
            return "Lillstugan"
        } else {
            return "Familj"
        }
    }

    getDisplayName(locale) {
        if (locale === 'en') {
            return this.display_name_en;
        } else {
            return this.display_name;
        }
    }

    getCleanedWeekString() {
        var weekString = this.weeks[0].toString();

        for (let i = 1; i < this.weeks.length; i++) {
            let shouldBeHidden = this.weeks[i]-1===this.weeks[i-1] && this.weeks[i+1]-1===this.weeks[i]
            if (![', ','-'].includes(weekString.at(-1))) {
                if (shouldBeHidden) {
                    weekString += '-'
                } else {
                    weekString += ', '
                }
            }
            if (!shouldBeHidden) {
                weekString += this.weeks[i].toString()
            }   
        }
        return weekString;
    }
}